(function (angular) {
    'use strict';

    angular.module('GorillaBoy.FileBrowser')
    .directive('gbFileBrowserListView', [
        'AppConstants',
        'SignalProvider',
        '$timeout',
        'MetricEvents',
        'ClientMetricsService',
        function (AppConstants, SignalProvider, $timeout, MetricEvents, ClientMetricsService) {
            return {
                restrict: 'E',
                templateUrl: './file-browser/list_view_type.html',
                link: function (scope, element, attrs) {
                    ClientMetricsService.recordCounterEvent(MetricEvents.LIST_VIEW, 1);
                    scope.draggedDocumentId = null;
                    scope.draggedFolderId = null;
                    scope.folderState.selectedAll = false;
                    if (scope.folderState.view !== AppConstants.ViewTypes.SEARCH_TYPE) {
                        /* show upload progress bar after the page is rendered.
                         * why in timeout? ==> https://stackoverflow.com/questions/12240639/how-can-i-run-a-directive-after-the-dom-has-finished-rendering
                         */
                        $timeout(function () {
                            scope.showFolderUploadProgressBar();
                        });
                    }
                }
            };
        }
    ])
    .directive('gbFileBrowserResourceHighlighter', [
        '$timeout', 'SignalProvider',
        function gbFileBrowserResourceHighlighter($timeout, SignalProvider) {
            return {
                restrict : 'A',
                link : function($scope, $element, $attrs) {
                    $scope.$on(SignalProvider.Folder.HighlightResource, highlightResource);
                    function highlightResource($event, resourceId) {
                        //Schedule the highlighter to be executed after the $digest() loop
                        $timeout(function() {
                            var $scrollContainer, domQueryPrefix;
                            if ($scope.folderState.viewType !== $scope.GalleryTypes.THUMBNAIL_VIEWTYPE) {
                                domQueryPrefix = 'li';
                            } else {
                                domQueryPrefix = 'div.thumbnail-wrapper';
                            }
                            $scrollContainer = $element.find(".file-view-scroll-wrapper");

                            var $elems = $element.find(domQueryPrefix + "[data-id='" + resourceId + "']");
                            if ($elems.length !== 1) {
                                return;
                            }
                            var elem = $elems.get(0);
                            scrollParentIfNecessaryAndHighlight($scrollContainer.get(0), elem);
                        }, 0, false);
                    }
                }
            };

            function highlightElement(elem) {
                var $elems = angular.element(elem);
                $elems.addClass('start-blink');
                $timeout(function() {
                    $elems.removeClass('start-blink');
                }, 1000, false);
            }

            function scrollParentIfNecessaryAndHighlight(scrollWrapper, elem) {
                var contBCR = scrollWrapper.getBoundingClientRect();
                var elemBCR = elem.getBoundingClientRect();

                var elemMidpoint = elemBCR.top + (elemBCR.bottom - elemBCR.top) / 2;
                var contMidpoint = contBCR.top + (contBCR.bottom - contBCR.top) / 2;

                var scrollTopDiff;
                if (contBCR.bottom < elemBCR.bottom) {
                    //the element is below the bottom edge
                    //Also add the clientHeight so that element comes in the middle
                    scrollTopDiff = elemBCR.bottom - contBCR.bottom + scrollWrapper.clientHeight / 2;
                } else if (contBCR.top > elemBCR.top) {
                    //the element is above the top edge. Take the negative of the below diff
                    //Also reduce the clientHeight so that element comes in the middle
                    scrollTopDiff = (elemBCR.top - contBCR.top) - scrollWrapper.clientHeight / 2;
                }
                if (!scrollTopDiff && elemMidpoint > contMidpoint) {
                    //the element could be in the viewport but we still need to bring it in the middle
                    scrollTopDiff = elemMidpoint - contMidpoint;
                }
                if (scrollTopDiff) {
                    angular.element(scrollWrapper).animate({
                        scrollTop : scrollWrapper.scrollTop + scrollTopDiff
                    }, {
                        easing: 'swing',
                        complete : highlightElement.bind(window, elem)
                    });
                } else {
                    highlightElement(elem);
                }
            }
        }
    ])
    .directive('loadMoreTrigger', [
        '$timeout',
        'SignalProvider',
        function ($timeout, SignalProvider) {
            /* This derivative emits load more signal when there is a pagination mark and (a) or (b):
             * a) the <load-more-trigger> is in the viewport
             * b) scroll near the end of the scrollableContainer
             */
            return {
                restrict: 'E',
                template: '<div ng-if="isLoading" class="centered">' +
                                '<div class="progress-indicator"></div>' +
                           '</div>',
                scope: {
                    scrollableContainerClass : "@",
                },
                link: function ($scope, $element, $attrs) {
                    var SCROLL_BOTTOM_MAX_IN_PX = 250;
                    var scrollableContainer = $element.closest('.' + $scope.scrollableContainerClass);
                    var scrollHandler = _.throttle(function loadMoreTriggerScrollHandlerFn() {
                        if (isNearTheEnd()) {
                            triggerLoadMoreWithDigest();
                        }
                    }, 100);

                    var ContentLoadingStartHandler = function() {
                        $scope.isLoading = true;
                    };

                    var ContentLoadingDoneHandler = function() {
                        $scope.isLoading = false;
                        $timeout(checkIfInViewportAndTriggerLoadMore, false);
                    };

                    var resizeHandler = _.debounce(checkIfInViewportAndTriggerLoadMore, 150);

                    $scope.$on(SignalProvider.ContentLoading.Done, ContentLoadingDoneHandler);
                    $scope.$on(SignalProvider.ContentLoading.Start, ContentLoadingStartHandler);
                    scrollableContainer.on('scroll', scrollHandler);
                    $(window).on('resize', resizeHandler);

                    $scope.$on('$destroy', function() {
                        scrollableContainer.off('scroll', scrollHandler);
                        $(window).off('resize', resizeHandler);
                    });

                    function checkIfInViewportAndTriggerLoadMore() {
                        if(isInViewport($element)) {
                            triggerLoadMoreWithDigest();
                        }
                    }

                    function triggerLoadMoreWithDigest() {
                        $scope.$applyAsync(function() {
                            $scope.$emit(SignalProvider.ContentLoading.LoadMore);
                        });
                    }

                    function isInViewport(element) {
                        var elementTop = element.get(0).getBoundingClientRect().top;
                        var elementBottom = element.get(0).getBoundingClientRect().bottom;
                        var viewportTop = 0;
                        var viewportBottom = window.innerHeight;

                        return (elementTop < viewportBottom) && (elementBottom > viewportTop);
                    }

                    function isNearTheEnd() {
                        var el = scrollableContainer.get(0);
                        var scrollTop = scrollableContainer.scrollTop() || 0,
                            scrollHeight = el.scrollHeight,
                            containerHeight = el.offsetHeight;

                        return (scrollHeight - (scrollTop + containerHeight) < SCROLL_BOTTOM_MAX_IN_PX);
                    }
                }
            };
        }
    ])
    .directive('noteFolderListView', [function () {
            return {
                restrict: 'E',
                templateUrl: './file-browser/note_folder_list_view.html'
            };
        }
    ])
    .directive('noteFileListView', [function () {
            return {
                restrict: 'E',
                templateUrl: './file-browser/note_file_list_view.html'
            };
        }
    ])
    .directive('folderDropdownMenu', [function () {
            return {
                restrict: 'E',
                templateUrl: './file-browser/folder_dropdown.html'
            };
        }
    ])
    .directive('fileDropdownMenu', [function () {
            return {
                restrict: 'E',
                templateUrl: './file-browser/file_dropdown.html'
            };
        }
    ]);
}(angular));
